module.exports = __webpack_public_path__ + "static/media/lowresportfolio-11.3a646b4d.jpg";